<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive " style="border: solid 1px rgba(0, 0, 0, 0.12); margin-bottom: 20px;">
            <table id="searchResult" mat-table [dataSource]="dataSource" matSort #sort1="matSort"
                class="mat-elevation-z8 tw-h-full tw-overflow-x-auto tw-overflow-y-hidden"
                style="width: 100%; min-width: 1200px; border: solid 1px rgba(0, 0, 0, 0.12);">

                <ng-container matColumnDef="select">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="width: 4em; min-width: 4em;">対象</th>
                    <td mat-cell *matCellDef="let row; let i = index" class="text-center">
                        <mat-checkbox color="primary" (change)="$event ? (selection.toggle(row)) : null;"
                            [checked]="selection.isSelected(row) || row.lossyoteiStsCode === '04'|| row.lossyoteiStsCode === '05'"
                            [disabled]="row.lossyoteiStsCode === '04'|| row.lossyoteiStsCode === '05'">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 120px;">支払契約番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo}}</td>
                </ng-container>
                <ng-container matColumnDef="visitormei">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 95px;">請求先名</th>
                    <td mat-cell *matCellDef="let row">{{ row.visitormei }}</td>
                </ng-container>
                <ng-container matColumnDef="lossJudgmentdivisionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double table-cell-type-num"
                        *matHeaderCellDef mat-sort-header style="min-width: 60px;">欠損<br>判定<br>区分</th>
                    <td mat-cell *matCellDef="let row">{{ row.lossJudgmentdivisionAname }}</td>
                </ng-container>
                <ng-container matColumnDef="apprvReqDate">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 80px;">承認依頼日</th>
                    <td mat-cell *matCellDef="let row">{{ row.apprvReqDate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="lossReasonAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 150px;">欠損理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.lossReasonAname }}</td>
                </ng-container>
                <ng-container matColumnDef="heisenDate">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 80px;">利用停止日</th>
                    <td mat-cell *matCellDef="let row">{{ row.heisenDate | dateString }}</td>
                </ng-container>
                <ng-container matColumnDef="heisenReasonAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 150px;">利用停止理由</th>
                    <td mat-cell *matCellDef="let row">{{ row.heisenReasonAname }}</td>
                </ng-container>
                <ng-container matColumnDef="chargeClsfyAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 90px;">料金種別</th>
                    <td mat-cell *matCellDef="let row">{{ row.chargeClsfyAname }}</td>
                </ng-container>
                <ng-container matColumnDef="lossMny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">欠損金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.lossMny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="inSumaddLeasefee">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">内合算<br>リース料金[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.inSumaddLeasefee | number }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="dryrskAmt">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">延滞<br>利息額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.dryrskAmt | number }}</td>
                </ng-container>
                <ng-container matColumnDef="lossSumMny">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 105px;">欠損合計<br>金額[円]</th>
                    <td mat-cell class="table-cell-type-num" *matCellDef="let row">{{ row.lossSumMny | number }}</td>
                </ng-container>
                <ng-container matColumnDef="pressmanagementdivisionAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 90px;">督促管理区分</th>
                    <td mat-cell *matCellDef="let row">{{ row.pressmanagementdivisionAname }}</td>
                </ng-container>
                <ng-container matColumnDef="pressTantoAreaAname">
                    <th mat-header-cell mat-sort-header-container class="border-bottom-double" *matHeaderCellDef
                        mat-sort-header style="min-width: 66px;">督促<br>管理地区</th>
                    <td mat-cell *matCellDef="let row">{{ row.pressTantoAreaAname }}</td>
                </ng-container>
                <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumnsCol; sticky: true">
                </tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol" class="clickable-mat-row"
                    (dblclick)="onDblClickRow(row)"></tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
        <ng-container>
            <div
                class="btn_area_right tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions>
                    <button type="button" [disabled]="isOutputBtnDisabled" mat-raised-button color="primary" class="btn"
                        (click)="onClickOutput()">出力</button>
                    <button type="button" [disabled]="false" mat-raised-button color="primary" class="btn"
                        (click)="onClickApproval()" [disabled]="selection.selected.length <= 0">承認</button>
                </mat-card-actions>
            </div>
        </ng-container>
    </mat-card-content>
</mat-card>